export default {"src":"/_next/static/media/lab-tool.7d67bd62.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};